export default __webpack_public_path__ + "static/media/brendan_nelson.b872bf8f.jpg";